// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.diff-line {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--base-colors-white-white100) / var(--tw-bg-opacity));
  flex-direction: row;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
  font-size: .75rem;
  line-height: 1rem;
  display: flex;
}

.diff-line__number {
  width: var(--base-sizes-16);
  text-align: right;
  -webkit-user-select: none;
  user-select: none;
  padding: var(--base-sizes-2);
}

.diff-line__number--inline-first {
  border-right: 1px solid #d6d6d6;
}

.diff-line__content {
  padding: var(--base-sizes-2);
  white-space: break-spaces;
  word-break: break-word;
  flex-direction: row;
  flex: 1 1 0;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Diff/DiffLine.css","webpack://./services/frontend/app/components/Diff/DiffLine.css"],"names":[],"mappings":"AADA;ECEE,kBAAkB;EAClB,+EAA+E;EAC/E,mBAAmB;EACnB,2GAA2G;EAC3G,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf","sourcesContent":[".diff-line {\n  display: flex;\n  flex-direction: row;\n  --tw-bg-opacity: 1;\n  background-color: rgb(var(--base-colors-white-white100) / var(--tw-bg-opacity));\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.diff-line__number {\n  width: var(--base-sizes-16);\n  text-align: right;\n  -webkit-user-select: none;\n          user-select: none;\n  padding: var(--base-sizes-2);\n}\n\n.diff-line__number--inline-first {\n  border-right: 1px solid #d6d6d6;\n}\n\n.diff-line__content {\n  display: flex;\n  flex: 1 1 0;\n  flex-direction: row;\n  padding: var(--base-sizes-2);\n\n  white-space: break-spaces;\n  word-break: break-word;\n}\n",".diff-line {\n  --tw-bg-opacity: 1;\n  background-color: rgb(var(--base-colors-white-white100) / var(--tw-bg-opacity));\n  flex-direction: row;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n  font-size: .75rem;\n  line-height: 1rem;\n  display: flex;\n}\n\n.diff-line__number {\n  width: var(--base-sizes-16);\n  text-align: right;\n  -webkit-user-select: none;\n  user-select: none;\n  padding: var(--base-sizes-2);\n}\n\n.diff-line__number--inline-first {\n  border-right: 1px solid #d6d6d6;\n}\n\n.diff-line__content {\n  padding: var(--base-sizes-2);\n  white-space: break-spaces;\n  word-break: break-word;\n  flex-direction: row;\n  flex: 1 1 0;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
